<template>
  <div id="dctop" class="parent_div">
    <div class="wrapper">
      <dd-header
        ref="menuRef"
        :headerType=2
        :cartCount="nowList? nowList.length : 0"
        :isDcPriceDisp="!userInfo.isProfitFlag"
      />
      <div class="container">
        <div id="select_category">
          <h1>➊ 商品カテゴリを選択してください</h1>
          <div id="category">
            <dd-category
              ref="ddCategoryListRef"
              :swipeList="categoryList"
              :swiperOptions="categoryOptions"
              :selectedCategory="selectedCategory"
              @selectCategory="selectCategory"
            />
          </div>
        </div>
        <div id="select_product">
          <h1>➋ 商品を選択してください</h1>
          <div id="select" v-if="false">
            <div>
              <select v-model="selectArea">
                <option value='' class="select_placeholder">地域:ALL</option>
                <option v-for="(area,index) in areaList" :key="'address-' + index" v-bind:value="area">{{area.name}}</option>
              </select>
            </div>
            <div>
              <select v-model="selectPrice">
                <option value='' class="select_placeholder">価格帯:ALL</option>
                <option v-for="(price,index) in priceList" :key="'address-' + index" v-bind:value="price">{{price.name}}</option>
              </select>
            </div>
            <div class="space" style="flex-shrink: 1"></div>
            <div>
              <div class="button01" id="construction">
                <input type="radio" name="construction_radio" id="construction_need" value=1 v-model.number="orderByNewest" />
                <label for="construction_need">新着順</label>
                <span>|</span>
                <input type="radio" name="construction_radio" id="construction_no" checked="" value=0 v-model.number="orderByNewest" />
                <label for="construction_no">人気順</label>
              </div>
            </div>
          </div>
          <!-- <div id="banner">
            <dd-banner
              ref="ddBannerListRef"
              :swipeList="bannerList"
              :swiperOptions="categoryOptions"
              :horizontalMode="false"
            />
          </div> -->
          <!-- <div class="customize_order">
            <div>
              <ul>
                <li>お客様の欲しい収納を</li>
                <li class="bold"><span class="pickup">個別にオーダー</span>承ります！</li>
                <li>掲載していない仕様やオーダー家具・収納に関してましても、ご相談承ります。</li>
              </ul>
            </div>
            <div class="order_detail">
              <div>詳細はこちら</div>
              <img :src="getImage('common/right_arrow.svg')">
            </div>
          </div> -->
          <div id="setplan">
            <div v-for="(product, index) in dcFileDataList" class="product" :key="'product-' + index" :value="product" @click="customize(product)">
              <img :src="getImage(product.dcFdImage)">
              <div class="product_detail">
                <div>
                  <p>{{product.corpData.corpName}}</p>
                  <p>{{product.seriesName}}</p>
                </div>
                <div>
                  <p class="bold">{{product.dcFdName}}</p>
                  <p class="pickup bold">{{productSize(product.dcMinWidth, product.dcMaxWidth)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
// import Vue from 'vue'
import axios from 'axios'

// common
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
// import * as Check from '../../utils/Check'
import {mapActions, mapState} from 'vuex'
// import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// import * as FormUtil from '../../utils/FormUtil'
import {PAYMENT_STATUS} from '../../constants/Type'
// import {COLOR_MATERIAL_TYPE} from '../constants/TypeEc'
import LoadingModal from '../../components/common/LoadingModal'
import CategorySwiper from '../components/common/CategorySwiper'
import BannerSwiper from '../components/common/BannerSwiper'
// import SwiperH from '../../components/common/SwiperH'
// import ToolTip from '../../components/common/ToolTip'
import Header from '../components/common/DcHeader'
import DDMenu from '../components/top/Menu'

// // content
// import ConstructPreview from '../components/top/product/common/ConstructPreview'
// import Manual from '../components/top/product/manual/Manual'
// import CupBoardManual from '../components/top/product/manual/CupboardManual'
// import ShoeManual from '../components/top/product/manual/ShoeManual'
// import CounterMiuraManual from '../components/top/product/manual/CounterMiura'
// import PlateMaterialManual from '../components/top/product/manual/PlateMaterialManual'
// import CounterUnderManual from '../components/top/product/manual/CounterUnderManual'
// // import MakerInfoModal from '../components/top/product/manual/miura/MakerInfoModal'
// import SideBoardManual from '../components/top/product/manual/SideBoardManual'
// import TvBoardManual from '../components/top/product/manual/TvBoardManual'
// import BookShelf from '../components/top/product/manual/BookShelf'
// import CabineMiuraSimpleNature from '../components/top/product/manual/CabineMiuraSimpleNature'
// import CabineMiuraLiteCountry from '../components/top/product/manual/CabineMiuraLiteCountry'
// import ShoecaseMiuraSimpleNature from '../components/top/product/manual/ShoecaseMiuraSimpleNature'
// import ShoecaseMiuraLiteCountry from '../components/top/product/manual/ShoecaseMiuraLiteCountry'
// import FmCloset from '../components/top/product/manual/Closet'
// import FmGasStorage from '../components/top/product/manual/GasStorage'

// input
// import ParamSize from '../components/top/input/paramater/ParamSize'
// import ParamSize2 from '../components/top/input/paramater/ParamSize2'
// import ParamSizeFiller from '../components/top/input/paramater/ParamSizeFiller'
// import ColorPallet from '../components/top/input/color/ColorPallet'

// // const
// const ptnFile = new RegExp('^.*series_shoe_SC-1[A-Z].*$')
// const ptnFile2 = new RegExp('^.*TVF.*$')
// const ptnFile3 = new RegExp('^.*BSA.*$')
// const ptnFile4 = new RegExp('^.*BSB.*$')
// const ptnFile5 = new RegExp('^.*DKF.*$')
// const ptnFile6 = new RegExp('^.*DKW.*$')
// const ptnFile7 = new RegExp('^.*CLL.*$')
// const ptnFile8 = new RegExp('^.*CLTA.*$')
// const ptnFile9 = new RegExp('^.*CLTB.*$')
// const ptnFile10 = new RegExp('^.*CLTC.*$')
// const ptnFile11 = new RegExp('^.*NSB.*$')
// const ptnFile12 = new RegExp('^.*NSLM.*$')
// const ptnFile13 = new RegExp('^.*NSLT.*$')
// const ptnFile14 = new RegExp('^.*NSO.*$')
// const ptnFile15 = new RegExp('^.*NSRM.*$')
// const ptnFile16 = new RegExp('^.*NSRT.*$')
// const CART_PRODUCT_MAX_COUNT = 30

export default {
  components: {
    'dd-header': Header,
    'dd-menu': DDMenu,
    // 'dd-manual': Manual,
    // 'dd-cup-manual': CupBoardManual,
    // 'dd-shoe-manual': ShoeManual,
    // 'dd-counter-miura-manual': CounterMiuraManual,
    // 'dd-plate-material-manual': PlateMaterialManual,
    // 'dd-counter-under-manual': CounterUnderManual,
    // 'dd-side-board-manual': SideBoardManual,
    // 'dd-tv-board-manual': TvBoardManual,
    // 'dd-book-shelf': BookShelf,
    // 'dd-cabine-miura-simple-nature': CabineMiuraSimpleNature,
    // 'dd-cabine-miura-lite-country': CabineMiuraLiteCountry,
    // 'dd-shoe-miura-simple-nature': ShoecaseMiuraSimpleNature,
    // 'dd-shoe-miura-lite-country': ShoecaseMiuraLiteCountry,
    // 'dd-fm-closet': FmCloset,
    // 'dd-fm-gas-storage': FmGasStorage,
    // 'dd-param-size': ParamSize,
    // 'dd-param-size2': ParamSize2,
    // 'dd-param-size-filler': ParamSizeFiller,
    // 'dd-color-pallet': ColorPallet,
    'dd-loading-modal': LoadingModal,
    // 'dd-construct-preview': ConstructPreview,
    'dd-category': CategorySwiper,
    'dd-banner': BannerSwiper
    // 'tool-tip': ToolTip,
    // 'dd-consturct': SwiperH
  },
  data () {
    return {
      // // メインフォーム
      // fileName: '',
      dcFileDataList: [],
      selCategoryData: {},
      selOpenPlanData: {},
      // // 空間情報
      // spaceJoincd: '',
      // // 1-1.収納スペース
      // targetPlan: {
      //   dcMinWidth: 0,
      //   dcMinHeight: 0,
      //   dcMinDepth: 0,
      //   dcMaxWidth: 0,
      //   dcMaxHeight: 0,
      //   dcMaxDepth: 0,
      //   dcProductCount: 1
      // },
      // 2.カラーを選択する
      // colorList: [],
      // colorDoor: {},
      // colorCabine: {},
      // colorCounter: {},
      // 3.オプション品を選択する
      // isAddShelf: false,
      // isAddFiller: false,
      // dcShelfCount: 0,
      // dcBoardCount: 1,
      // dcFillerCount: 0,
      // // 見積り関連
      businessDataList: [],
      // businessId: '',
      // selBusiness: {},
      // saveForm: {},
      // saveConstructForm: {},
      // isExistDelivery: true,
      // isStructSameAddress: true,
      // deliveryForm: {
      //   id: '',
      //   postcd: '',
      //   state: '',
      //   city: '',
      //   street: ''
      // },
      // constructForm: {
      //   id: '',
      //   postcd: '',
      //   state: '',
      //   city: '',
      //   street: ''
      // },
      // resrchForm: {
      //   postcd: '',
      //   state: '',
      //   city: '',
      //   street: ''
      // },
      // copyForm: {},
      // priceData: {},
      // // commonList: [],
      constructList: [],
      // isOrder: false,
      // workFlag: 0,
      // constructOpFlag: 0,
      // resrchFlag: 0,
      // leftSide: '',
      // rightSide: '',
      // isCounter: false,
      // // エラー
      // errors: {},
      // // フィラー・エンドパネルの設定
      // isLeftFilter: false,
      // isLeftEndPanel: false,
      // isRightFilter: false,
      // isRightEndPanel: false,
      categoryList: [],
      selectedCategory: 1,
      // tabType: 1,
      // isResrchSameAddress: true,
      // label: {
      //   postcd: '郵便番号'
      // },
      // userInfo: {},
      // planListOptions: {
      //   slidesPerGroup: 1,
      //   slidesPerView: 1,
      //   initialSlide: 0,
      //   slidesPerColumn: 1,
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev'
      //   },
      //   SimulateTouch: true,
      //   touchStartPreventDefault: false,
      //   preventClicks: true
      //   // spaceBetween: 5
      // },
      // buyFlag: false,
      // updateFlag: false,
      // saveFlag: false,
      // estimateFlag: false,
      // doResrchFlag: false,
      // imgQmark: App.getMmstyleResource('common/qmark_gray.svg'),
      // createPlanFlag: false,
      // runPlanList: [],
      // priceCalcText: '計算中',
      // priceCalcTimer: undefined,
      // deliErrMessage: ['恐れ入りますが、ご入力いただいた地域への納品、組立設置依頼は別途調整させていただきます。',
      //   'お問い合わせよりご希望の商品と納品先、組立設置先のご住所をご連絡ください。',
      //   '',
      //   '調整地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域。'
      // ],
      // resrchErrMessages: ['恐れ入りますが、ご入力いただいた地域への事前現場調査は別途調整させていただきます。',
      //   'お問い合わせよりご希望の商品と事前現場調査先のご住所をご連絡ください。',
      //   '',
      //   '調整地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域。'
      // ],
      // isWallEmbedded: false,
      // new ui
      // constructList: [
      //   this.getImage('top/construct/co_02_01.jpg'),
      //   this.getImage('top/construct/s_03_01.jpg'),
      //   this.getImage('top/construct/s_02_01.jpg'),
      //   this.getImage('top/construct/s_05_01.jpg')
      // ],
      // productList: [
      //   {id: 1, img: this.getImage('top/series/BSA_1.jpg'), imgB: this.getImage('top/series/BSA_1_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 2, img: this.getImage('top/series/BSA_2.jpg'), imgB: this.getImage('top/series/BSA_2_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 3, img: this.getImage('top/series/BSB_3.jpg'), imgB: this.getImage('top/series/BSB_3_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 4, img: this.getImage('top/series/BSB_4L.jpg'), imgB: this.getImage('top/series/BSB_4L_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 5, img: this.getImage('top/series/BSB_5L.jpg'), imgB: this.getImage('top/series/BSB_5L_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 6, img: this.getImage('top/series/C-1L.jpg'), imgB: this.getImage('top/series/C-1L_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 7, img: this.getImage('top/series/C-1R.jpg'), imgB: this.getImage('top/series/C-1R_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 8, img: this.getImage('top/series/C-2L.jpg'), imgB: this.getImage('top/series/C-2L_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 9, img: this.getImage('top/series/C-2R.jpg'), imgB: this.getImage('top/series/C-2R_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 10, img: this.getImage('top/series/C-3L.jpg'), imgB: this.getImage('top/series/C-3L_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 11, img: this.getImage('top/series/C-3R.jpg'), imgB: this.getImage('top/series/C-3R_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-01 扉 + ｵｰﾌﾟﾝ扉', size: '1000mm ＜ W ≦ 4500mm'},
      //   {id: 12, img: this.getImage('top/series/CLL-9.jpg'), imgB: this.getImage('top/series/CLL-9_B.jpg'), series: 'PICOシリーズ', corp: 'ファニチャーメーカー株式会社', title: 'TV-02 扉 + 下引出上ｵｰﾌﾟﾝ', size: '1000mm ＜ W ≦ 4500mm'}
      // ],
      areaList: [
        {id: 1, name: '北海道'},
        {id: 2, name: '東京都'}
      ],
      priceList: [
        {id: 1, name: '~１万円未満'},
        {id: 1, name: '1万円~2万円未満'},
        {id: 1, name: '2万円~3万円未満'}
      ],
      selectArea: {},
      selectPrice: {},
      orderByNewest: true,
      categoryOptions: {
        slidesPerView: 'auto',
        // slidesPerView: 10,
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        // loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0
      },
      bannerList: [
        {id: 1, img: this.getImage('top/series/BSA_1.jpg')},
        {id: 2, img: this.getImage('top/series/BSB_4L.jpg')},
        {id: 3, img: this.getImage('top/series/BSB_5R.jpg')}
      ]
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    init: function (id) {
      console.log('init')
      this.$refs.loadingModalRef.showModal(true)
      this.resrchFlag = 0
      this.workFlag = 0
      this.dcShelfCount = 0
      this.dcFillerCount = 0
      this.isWallEmbedded = false
      let payload = {
        params: {
          category: id
        }
      }
      axios.get(DC_URL.TOP + '/init', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.dcFileDataList = []
            response.data.data.dcFileDataList
              .forEach(f => {
                let dcFileData = this.convertDcFileData(f)
                this.dcFileDataList.push(dcFileData)
              })
            // this.dcFileDataList = response.data.data.dcFileDataList
            this.categoryList = response.data.data.categoryList
            if (id === undefined) {
              this.selCategoryData = this.categoryList[0]
            } else {
              this.selCategoryData = this.categoryList.find(c => c.id === id)
            }
            // ファイル選択
            this.businessDataList = response.data.data.businessDataList
            // if (!param) {
            this.selOpenPlanData = this.dcFileDataList[0]
            // param = {
            //   dcFdId: this.selOpenPlanData.dcFdId
            // }
            // } else {
            //   this.readSaveParam(param)
            //   this.selOpenPlanData = this.dcFileDataList.find(e => e.dcFdId === param.dcFdId)
            // }
            // this.selectePlan(param)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    selectCategory: function (category) {
      this.tabType = 1
      this.selCategoryData = category
      this.init(this.selCategoryData.id)
      this.errors = {}
      this.$forceUpdate()
    },
    // // 公開プランの選択、ローカルプランの作成
    // selectePlan: function (param) {
    //   this.$refs.loadingModalRef.showModal(true)
    //   let payload = {
    //     params: {
    //       dcFdId: this.selOpenPlanData.dcFdId
    //     }
    //   }
    //   this.targetPlan = Object.assign({}, this.selOpenPlanData)

    //   axios.get(DC_URL.TOP + '/select', payload)
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       } else {
    //         this.selectedPlan(response.data.data)
    //         if (this.createPlanFlag) {
    //           this.runPlanList.push(param)
    //         } else {
    //           this.createPlan(param)
    //         }
    //       }
    //     }).catch(error => {
    //       Api.handleError(error)
    //     }).finally(() => {
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    // readSaveParam: function (param) {
    //   console.log('readSaveParam')
    //   // 選択プラン
    //   this.selOpenPlanData = this.dcFileDataList.find(e => e.dcFdId === param.dcFdId)
    //   this.targetPlan = Object.assign({}, this.selOpenPlanData)
    //   // 納品先読み込み
    //   this.$set(this.deliveryForm, 'postcd', param.dcSaveDeliPostcd)
    //   this.isExistDelivery = param.dcSaveExistDeliFlag
    //   this.selBusiness = this.addressList.find(a => a.businessId === param.businessId)
    //   // 組立施工読み込み
    //   this.workFlag = param.dcWorkFlag ? 1 : 0
    //   this.isStructSameAddress = param.dcStructSameAddressFlag
    //   this.$set(this.constructForm, 'postcd', param.dcStructPostcd)
    //   this.constructOpFlag = param.dcConstructOpServiceFlag ? 1 : 0
    //   // 事前現場調査読み込み
    //   this.resrchFlag = param.dcSaveResrchFlag ? 1 : 0
    //   this.$set(this.resrchForm, 'postcd', param.dcSaveResrchPostcd)
    //   this.isResrchSameAddress = param.dcSaveSameAddressFlag

    //   // 棚板のご注文数を保持
    //   if (param.categoryId === 5) {
    //     this.dcBoardCount = param.dcShelfCount ? param.dcShelfCount : 0
    //   }
    // },
    // // セットプラン選択後のクライアント側の対応
    // selectedPlan: function (data) {
    //   // this.dcFdName = data.dcFileData.dcFdName
    //   this.$set(this.targetPlan, 'corpData', data.dcFileData.corpData)
    //   // カラーリストを設定
    //   this.colorList = []
    //   data.dcColorList
    //     .forEach(e => {
    //       let color = {
    //         id: e.no,
    //         name: e.name,
    //         type: e.type,
    //         no: e.dispNo,
    //         img: this.getImage('color/' + e.img),
    //         imgB: this.getImage('color/' + this.bigImage(e.img))
    //       }
    //       this.colorList.push(color)
    //     })
    //   // 初期カラー選択
    //   this.$nextTick(function () {
    //     if (this.doorColorList.length > 0) {
    //       let color = this.doorColorList.find(c => c.id === data.dcParamModel.dcColorDoor)
    //       this.selectDoorColor(color !== undefined ? color : this.doorColorList[0])
    //     } else {
    //       this.selectDoorColor(null)
    //     }
    //     if (this.cabineColorList.length > 0) {
    //       let color = this.cabineColorList.find(c => c.id === data.dcParamModel.dcColorBox)
    //       this.selectCabineColor(color !== undefined ? color : this.cabineColorList[0])
    //     } else {
    //       this.selectCabineColor(null)
    //     }
    //     if (this.counterColorList.length > 0) {
    //       let color = this.counterColorList.find(c => c.id === data.dcParamModel.dcColorCounter)
    //       this.selectCounterColor(color !== undefined ? color : this.counterColorList[0])
    //     } else {
    //       this.selectCounterColor(null)
    //     }
    //   })
    //   // 追加可動棚の設定
    //   if (data.dcParamModel.dcShelfCount && data.dcParamModel.dcShelfCount > 0) {
    //     this.isAddShelf = true
    //     this.dcShelfCount = data.dcParamModel.dcShelfCount
    //   } else {
    //     this.isAddShelf = false
    //   }
    //   if (data.dcParamModel.dcFillerCount && data.dcParamModel.dcFillerCount > 0) {
    //     this.isAddFiller = true
    //     this.dcFillerCount = data.dcParamModel.dcFillerCount
    //   } else {
    //     this.isAddFiller = false
    //   }
    //   // this.commonList = data.commonList
    //   // 組立設置例の設定
    //   this.constructList = []
    //   data.constructList
    //     .forEach(c => {
    //       let construct = {
    //         id: c.id,
    //         dcFdId: c.dcFdId,
    //         price: c.price,
    //         img: this.getImage('top/construct/' + c.img),
    //         imgB: this.getImage('top/construct/' + this.bigImage(c.img))
    //       }
    //       this.constructList.push(construct)
    //     })
    // },
    // createPlan: function (param) {
    //   let payload = Object.assign({}, param)
    //   console.log('start create ' + param.dcFdId)
    //   this.createPlanFlag = true
    //   axios.post(DC_URL.TOP + '/create', payload)
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       } else {
    //         console.log('ret create ' + param.dcFdId)
    //         this.spaceJoincd = response.data.data.spaceJoincd
    //         this.priceData = response.data.data.priceData
    //         this.clearPriceCalcTimer()
    //         this.nextPlan()
    //       }
    //     }).catch(error => {
    //       Api.handleError(error)
    //     }).finally(() => {
    //     })
    //   // }
    // },
    // nextPlan: function () {
    //   if (this.runPlanList.length === 0) {
    //     console.log('run plan list zero')
    //     this.createPlanFlag = false
    //     return
    //   }
    //   console.log('next plan ' + this.runPlanList[this.runPlanList.length - 1])
    //   this.createPlan(this.runPlanList[this.runPlanList.length - 1])
    //   this.runPlanList = []
    // },
    convertDcFileData: function (data) {
      let dcFileData = {
        dcFdId: data.dcFdId,
        dcCategoryType: data.dcCategoryType,
        dcFdName: data.dcFdName,
        dcFileName: data.dcFileName,
        seriesName: data.seriesName,
        dcFdImage: data.dcFdImage,
        dcFdImageB: this.bigImage(data.dcFdImage),
        dcWidth: data.defW,
        dcMinWidth: data.minW,
        dcMaxWidth: data.maxW,
        dcHeight: data.defH,
        dcMinHeight: data.minH,
        dcMaxHeight: data.maxH,
        dcDepth: data.defD,
        dcMinDepth: data.minD,
        dcMaxDepth: data.maxD,
        dcHeight2: data.defH2,
        dcMinHeight2: data.minH2,
        dcMaxHeight2: data.maxH2,
        dcDepth2: data.defD2,
        dcMinDepth2: data.minD2,
        dcMaxDepth2: data.maxD2,
        dcBType: data.btype,
        dcBSize: data.bsize,
        dcCType: data.ctype,
        dcCSize: data.csize,
        dcDType: data.dtype,
        dcDSize: data.dsize,
        dcProductCount: 1,
        dcBTypeDisableFlg: data.btypeDisableFlg,
        dcCTypeDisableFlg: data.ctypeDisableFlg,
        dcDTypeDisableFlg: data.dtypeDisableFlg,
        opShelfDisableFlg: data.opShelfDisableFlg,
        opFillerDisableFlg: data.opFillerDisableFlg,
        opShelfType: data.opShelfType,
        opFillerType: data.opFillerType,
        corpData: data.corpData,
        inputReferenceList: data.inputReferenceList,
        cDcProductManual: data.dcProductManual,
        cDcConstructManual: data.dcConstructManual,
        cDcUserManual: data.dcUserManual,
        categoryImg: data.categoryImg,
        categoryName: data.categoryName
      }
      return dcFileData
    },
    // postcdCompleteDelivery: async function () {
    //   console.log('do postcdCompleteDelivery1')
    //   if (!this.validateDeliImpossiblePostCd(this.deliveryForm.postcd, this.deliErrMessage)) {
    //     delete this.errors.deliveryPostcd
    //     console.log('postcd is delivery impossible.')
    //     return
    //   }
    //   await FormUtil.addressCompletion(this.deliveryForm.postcd, (address) => {
    //     this.$set(this.deliveryForm, 'state', address.state)
    //     this.$set(this.deliveryForm, 'city', address.city)
    //     this.$set(this.deliveryForm, 'street', address.street)
    //     // チェック処理
    //     console.log('do postcdCompleteDelivery2')
    //   })
    // },
    // postcdCompleteStruct: async function () {
    //   console.log('do postcdCompleteStruct1')
    //   if (!this.workFlag) return
    //   let postcd = this.constructForm.postcd
    //   if (this.isStructSameAddress) {
    //     postcd = this.deliveryForm.postcd
    //   }
    //   // 配送不可チェック
    //   if (!this.validateDeliImpossiblePostCd(postcd, this.deliErrMessage)) {
    //     delete this.errors.constructPostcd
    //     console.log('postcd is construct impossible.')
    //     return
    //   }
    //   await FormUtil.addressCompletion(postcd, (address) => {
    //     this.$set(this.constructForm, 'state', address.state)
    //     this.$set(this.constructForm, 'city', address.city)
    //     this.$set(this.constructForm, 'street', address.street)
    //     // チェック処理
    //     console.log('do postcdCompleteStruct2')
    //   })
    // },
    // postcdCompleteResrch: async function () {
    //   // 配送不可チェック
    //   if (!this.resrchFlag) return
    //   let postcd = this.resrchForm.postcd
    //   if (this.isResrchSameAddress) {
    //     postcd = this.deliveryForm.postcd
    //   }
    //   await FormUtil.addressCompletion(postcd, (address) => {
    //     this.$set(this.resrchForm, 'state', address.state)
    //     this.$set(this.resrchForm, 'city', address.city)
    //     this.$set(this.resrchForm, 'street', address.street)
    //   })
    // },
    // selectSwipePlan: function (obj) {
    //   let selPlan = this.dcFileDataList.find(p => p.dcFdId === obj.id)
    //   this.selectePlan(selPlan)
    // },
    // onReEstimate: async function () {
    //   try {
    //     console.log('do update1')
    //     if (this.updateFlag) return
    //     console.log('do update2')
    //     this.updateFlag = true
    //     this.$refs.loadingModalRef.showModal(true)
    //     await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
    //     if (!this.checkInputParam()) {
    //       console.log('Failed to check input parameters')
    //       return
    //     }
    //     this.update()
    //   } catch (error) {
    //     console.log('doupdate cacth')
    //   } finally {
    //     console.log('doupdate finally')
    //     this.updateFlag = false
    //     this.$refs.loadingModalRef.showModal(false)
    //   }
    // },
    // // ローカルプランの更新
    // update: async function () {
    //   console.log('update')
    //   let payload = this.topForm
    //   await axios.post(DC_URL.TOP + '/update', payload
    //   )
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       } else {
    //         // 金額とファイルを更新
    //         this.priceData = response.data.data.priceData
    //         this.spaceJoincd = response.data.data.spaceJoincd
    //       }
    //     }).catch(error => {
    //       Api.handleError(error)
    //     })
    // },
    // save: async function () {
    //   if (this.saveFlag) return
    //   this.saveFlag = true
    //   // this.$refs.loadingModalRef.showModal(true)
    //   await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
    //   if (!this.checkInputParam()) {
    //     console.log('Failed to check input parameters')
    //     this.saveFlag = false
    //     // this.$refs.loadingModalRef.showModal(false)
    //     return
    //   }
    //   let modalData = {
    //     title: '',
    //     messages: ['保存名を入力してください。'],
    //     modalType: 'confirm',
    //     textAlign: 'center',
    //     okBtnLabel: '保存',
    //     callbackParams: {},
    //     onOk: (callback) => {
    //       let payload = this.topForm
    //       this.$set(payload, 'saveName', callback.saveName)
    //       this.$refs.loadingModalRef.showModal(true)
    //       axios.post(DC_URL.SAVE, payload
    //       ).then(response => {
    //         if (response.data.errorMessage) {
    //           this.handleErrorMessage(response)
    //           this.$refs.loadingModalRef.showModal(false)
    //         } else {
    //           console.log('show save dialog')
    //           App.showModal({
    //             title: '',
    //             messages: ['商品情報が保存されました'],
    //             messageType: 'success',
    //             layoutType: 'layout-classic',
    //             modalType: 'confirm',
    //             textAlign: 'center',
    //             okBtnLabel: '閉じる',
    //             cancelBtnLabel: '保存リスト',
    //             onOk: () => {
    //               // 特になし
    //               console.log('save dialog click ok button')
    //             },
    //             onCancel: () => {
    //               this.$router.push({
    //                 name: 'SaveItemList'
    //               })
    //             }
    //           })
    //         }
    //       }).catch(error => {
    //         Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
    //         App.showModal({
    //           title: 'システムエラー',
    //           messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
    //           messageType: 'error',
    //           textAlign: 'left'
    //         })
    //       }).finally(() => {
    //         console.log('save finally')
    //         this.$refs.loadingModalRef.showModal(false)
    //       })
    //     }
    //   }
    //   AppEc.showProductSave(modalData)
    //   this.saveFlag = false
    // },
    // // 見積り・図面ダイアログを表示
    // onShowEstimateModal: async function () {
    //   console.log('run planning data. ' + this.runPlanList.length)
    //   console.log('create plan flag. ' + this.createPlanFlag)
    //   // 多重防止
    //   if (this.estimateFlag) return
    //   this.estimateFlag = true
    //   this.$refs.loadingModalRef.showModal(true)
    //   await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
    //   // チェック処理
    //   if (!this.checkInputParam()) {
    //     this.$refs.loadingModalRef.showModal(false)
    //     this.estimateFlag = false
    //     return
    //   }
    //   // 画面データを渡す
    //   let payload = this.topForm
    //   axios.post(DC_URL.TOP + '/order', payload
    //   )
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //         this.$refs.loadingModalRef.showModal(false)
    //       } else {
    //         // 金額とファイルを更新
    //         this.priceData = response.data.data.priceData
    //         this.spaceJoincd = response.data.data.spaceJoincd
    //         // ダイアログ表示
    //         let modalData = {
    //           onOk: () => {
    //             this.buy(response.data.data.constructOpAddressData)
    //           },
    //           showSuccess: () => {
    //             this.$refs.loadingModalRef.showModal(false)
    //           },
    //           fileName: this.fileName,
    //           titleDoor: this.titleDoor(),
    //           colorDoor: this.colorDoor,
    //           titleCabine: this.titleCabine(),
    //           colorCabine: this.colorCabine,
    //           titleCounter: this.titleCounter(),
    //           colorCounter: this.colorCounter,
    //           priceData: this.priceData,
    //           spaceJoincd: this.spaceJoincd,
    //           dispOrderButton: true,
    //           dcProductCount: Number(this.targetPlan.dcProductCount),
    //           isCalcDelivery: true,
    //           isDrawing: this.selCategoryData.id !== 5,
    //           corpData: this.corpData,
    //           isProfitFlag: true,
    //           isProductData: true
    //         }
    //         AppEc.showEstimateModal(modalData)
    //         this.estimateFlag = false
    //       }
    //     }).catch(error => {
    //       Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
    //       App.showModal({
    //         title: 'システムエラー',
    //         messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
    //         messageType: 'error',
    //         textAlign: 'left'
    //       })
    //     }).finally(() => {
    //       this.$refs.loadingModalRef.showModal(false)
    //       this.estimateFlag = false
    //     })
    // },
    // buy: function (constructOpAddressData) {
    //   if (this.nowList.length >= CART_PRODUCT_MAX_COUNT) {
    //     App.showModal({
    //       messages: ['カートに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
    //     })
    //     return
    //   }
    //   // 多重防止
    //   if (this.buyFlag) return
    //   this.buyFlag = true
    //   App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    //   App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    //   App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    //   App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    //   if (this.isExistDelivery) {
    //     App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
    //   }
    //   App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, this.topForm)
    //   App.setLocalStorage(DC_STORAGE_KEY.FILE_NAME, this.fileName)
    //   this.addCart()
    // },
    // checkInputParam: function () {
    //   console.log('check input param')
    //   // 入力チェック
    //   this.errors = {}
    //   let isCheckParam = this.$refs.paramCommonRef.checkParam()
    //   this.validateProductCnt()
    //   this.validateColor()
    //   this.validateRequireDeliveryPostcd()
    //   if (this.isConstruct) {
    //     this.validateRequireConstructPostcd()
    //   }
    //   if (this.resrchFlag) {
    //     this.validateRequireResrchPostcd()
    //   }
    //   if (Object.keys(this.errors).length !== 0 || !isCheckParam) {
    //     this.showErrorInput()
    //     return false
    //   }
    //   return true
    // },
    // TODO 既存で未使用
    // loadInput: function () {
    //   let ltopForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    //   if (Object.keys(ltopForm).length > 0) {
    //     this.$set(this.topForm, 'postcd', ltopForm.postcd)
    //     this.$set(this.topForm, 'state', ltopForm.state)
    //     this.$set(this.topForm, 'city', ltopForm.city)
    //     this.$set(this.topForm, 'street', ltopForm.street)
    //     this.$set(this.topForm, 'workFlag', ltopForm.workFlag)
    //     this.$set(this.topForm, 'isStructSameAddress', ltopForm.isStructSameAddress)
    //     this.$set(this.topForm, 'structPostcd', ltopForm.structPostcd)
    //     this.$set(this.topForm, 'structState', ltopForm.structState)
    //     this.$set(this.topForm, 'structCity', ltopForm.structCity)
    //     this.$set(this.topForm, 'structStreet', ltopForm.structStreet)
    //     this.$set(this.topForm, 'constructOpFlag', ltopForm.constructOpFlag)
    //     this.$set(this.topForm, 'resrchFlag', ltopForm.resrchFlag)
    //   }
    // },
    // addCart: function () {
    //   this.$refs.loadingModalRef.showModal(true)
    //   axios.get(DC_URL.TOP + '/buy')
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //         this.$refs.loadingModalRef.showModal(false)
    //       } else {
    //         this.$store.dispatch('loadCartData')
    //         App.showModal({
    //           title: '',
    //           messages: ['商品がカートに追加されました。'],
    //           messageType: 'success',
    //           layoutType: 'layout-classic',
    //           modalType: 'confirm',
    //           textAlign: 'center',
    //           okBtnLabel: '閉じる',
    //           cancelBtnLabel: 'カートを見る',
    //           onOk: () => {
    //             // 特になし
    //           },
    //           onCancel: () => {
    //             this.$router.push({
    //               name: 'Cart'
    //             })
    //           }
    //         })
    //         this.$refs.loadingModalRef.showModal(false)
    //       }
    //     }).catch(error => {
    //       Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
    //       App.showModal({
    //         title: 'システムエラー',
    //         messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
    //         messageType: 'error',
    //         textAlign: 'left'
    //       })
    //       this.$refs.loadingModalRef.showModal(false)
    //     }).finally(() => {
    //       this.buyFlag = false
    //     })
    // },
    // resrch: async function () {
    //   // 多重防止
    //   if (this.doResrchFlag) return
    //   this.doResrchFlag = true
    //   this.errors = {}
    //   this.$refs.loadingModalRef.showModal(true)
    //   await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct(), this.postcdCompleteResrch()])
    //   // チェック処理
    //   if (!this.checkInputParam()) {
    //     this.doResrchFlag = false
    //     this.$refs.loadingModalRef.showModal(false)
    //     return
    //   }
    //   // 画面データを渡す
    //   let payload = this.topForm
    //   axios.post(DC_URL.TOP + '/order', payload
    //   ).then(response => {
    //     if (response.data.errorMessage) {
    //       this.handleErrorMessage(response)
    //       this.$refs.loadingModalRef.showModal(false)
    //     } else {
    //       App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
    //       App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
    //       App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    //       App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    //       // 金額とファイルを更新
    //       this.priceData = response.data.data.priceData
    //       this.spaceJoincd = response.data.data.spaceJoincd
    //       // ダイアログ表示
    //       let modalData = {
    //         onOk: () => {
    //           let topForm = {
    //             categoryId: this.selCategoryData.id,
    //             topSpace: this.targetPlan,
    //             titleDoor: this.titleDoor(),
    //             colorDoor: this.colorDoor,
    //             titleCabine: this.titleCabine(),
    //             colorCabine: this.colorCabine,
    //             titleCounter: this.titleCounter(),
    //             colorCounter: this.colorCounter,
    //             dcWorkFlag: this.isConstruct,
    //             isLeftFiller: this.isLeftFiller,
    //             isRightFiller: this.isRightFiller,
    //             dcShelfCount: this.opShelfCount,
    //             dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
    //             spaceJoincd: this.spaceJoincd,
    //             dcProductCount: this.targetPlan.dcProductCount,
    //             pageList: this.getPageList,
    //             postcd: this.resrchForm.postcd,
    //             state: this.resrchForm.state,
    //             city: this.resrchForm.city,
    //             street: this.resrchForm.street,
    //             resrchFlag: this.resrchFlag
    //           }
    //           App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    //           App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    //           App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    //           App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    //           if (this.isExistDelivery && this.isResrchSameAddress) {
    //             App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
    //           }
    //           App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, topForm)
    //           App.setLocalStorage(DC_STORAGE_KEY.PRICE_DATA, this.priceData)
    //           App.setLocalStorage(DC_STORAGE_KEY.FILE_NAME, this.fileName)
    //           this.$router.push({
    //             name: 'BuildingResearchBusiness'
    //           })
    //         },
    //         showSuccess: () => {
    //           this.$refs.loadingModalRef.showModal(false)
    //         },
    //         fileName: this.fileName,
    //         titleDoor: this.titleDoor(),
    //         colorDoor: this.colorDoor,
    //         titleCabine: this.titleCabine(),
    //         colorCabine: this.colorCabine,
    //         titleCounter: this.titleCounter(),
    //         colorCounter: this.colorCounter,
    //         priceData: this.priceData,
    //         spaceJoincd: this.spaceJoincd,
    //         dispOrderButton: true,
    //         dcProductCount: this.targetPlan.dcProductCount,
    //         isCalcDelivery: true,
    //         resrchFlag: this.resrchFlag === 1
    //       }
    //       AppEc.showEstimateSrchModal(modalData)
    //       this.doResrchFlag = false
    //     }
    //   }).catch(error => {
    //     Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
    //     App.showModal({
    //       title: 'システムエラー',
    //       messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
    //       messageType: 'error',
    //       textAlign: 'left'
    //     })
    //     this.$refs.loadingModalRef.showModal(false)
    //     this.doResrchFlag = false
    //   }).finally(() => {
    //   })
    // },
    // TODO 既存で未使用
    // moveOrder: function () {
    //   this.$router.push('/mmstyle/order/input')
    // },
    // newTabSupport: function () {
    //   let newWindow = window.open('/#/mmstyle/support/input', 'support')
    //   newWindow.location.reload()
    // },
    // selectDoorColor: function (color) {
    //   this.colorDoor = color
    // },
    // selectCabineColor: function (color) {
    //   this.colorCabine = color
    // },
    // selectCounterColor: function (color) {
    //   this.colorCounter = color
    // },
    // validateNumber: function (event) {
    //   if (!Check.isNumber(event.key)) {
    //     event.preventDefault()
    //     return false
    //   }
    //   return true
    // },
    // convertHalfNumber: function (event) {
    //   // 郵便番号や電話番号で最初に0がくる場合があるため別で用意
    //   let str = FormUtil.restHalfNumber(event.target.value)
    //   return str
    // },
    // inputRestNumber: function (event) {
    //   // テキスト補正
    //   let str = FormUtil.restHalfNumber(event.target.value)
    //   str = FormUtil.deleteTopZero(str)
    //   return str
    // },
    // onBlurOpShelfCount: function () {
    //   if (!this.dcShelfCount || this.dcShelfCount <= 0) {
    //     this.dcShelfCount = 0
    //   }
    // },
    // onBlurOpBoardCount: function () {
    //   if (!this.dcBoardCount || this.dcBoardCount <= 0) {
    //     this.dcBoardCount = 1
    //   }
    // },
    // onBlurOpFillerCount: function () {
    //   if (!this.dcFillerCount || this.dcFillerCount <= 0) {
    //     this.dcFillerCount = 0
    //   }
    // },
    // onBlurProductCount: function () {
    //   if (!this.targetPlan.dcProductCount || this.targetPlan.dcProductCount <= 0) {
    //     this.targetPlan.dcProductCount = 0
    //   }
    // },
    // 加工例を選択
    previewConstruct: function (img, category, target) {
      let modalData = {
        image: img,
        category: category
      }
      AppEc.showImageViewerModal(modalData)
    },
    // validateProductCnt: function () {
    //   let ret = true
    //   if (!Check.isNumber(this.targetPlan.dcProductCount)) {
    //     this.errors['product'] = 'ご注文数は数値で入力してください。'
    //     ret = false
    //   } else {
    //     delete this.errors.product
    //     ret = true
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateColor: function () {
    //   let ret = true
    //   if (!this.colorDoor && !this.colorCabine && !this.colorCounter) {
    //     this.errors['Color'] = 'カラーが選択されていません。'
    //     ret = false
    //   } else {
    //     delete this.errors.Color
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateRequireDeliveryPostcd: function () {
    //   let ret = true
    //   // 登録済みを選択して、保存リストを選択していなかった場合
    //   if (this.isExistDelivery && Object.keys(this.selBusiness).length === 0) {
    //     this.errors['selectList'] = '項目を選択してください'
    //     ret = false
    //   } else if (!this.deliveryForm.postcd && this.deliveryForm.postcd.length <= 0) {
    //     this.errors['deliveryPostcd'] = this.label.postcd + 'は必須項目です'
    //     ret = false
    //   } else if (!Check.isPostCd(this.deliveryForm.postcd)) {
    //     this.errors['deliveryPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
    //     ret = false
    //   } else if (!FormUtil.isExistPostcd(this.deliveryForm.postcd)) {
    //     this.errors['deliveryPostcd'] = this.label.postcd + 'が存在しません。'
    //     ret = false
    //   } else {
    //     delete this.errors.deliveryPostcd
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateRequireConstructPostcd: function () {
    //   let ret = true
    //   // 登録済みを選択して、保存リストを選択していなかった場合
    //   if (!this.isStructSameAddress) {
    //     if (!this.constructForm.postcd && this.constructForm.postcd.length <= 0) {
    //       this.errors['constructPostcd'] = this.label.postcd + 'は必須項目です'
    //       ret = false
    //     } else if (!Check.isPostCd(this.constructForm.postcd)) {
    //       this.errors['constructPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
    //       ret = false
    //     } else if (!FormUtil.isExistPostcd(this.constructForm.postcd)) {
    //       this.errors['constructPostcd'] = this.label.postcd + 'が存在しません。'
    //       ret = false
    //     } else {
    //       delete this.errors.constructPostcd
    //     }
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateRequireResrchPostcd: function () {
    //   let ret = true
    //   // 登録済みを選択して、保存リストを選択していなかった場合
    //   if (!this.isResrchSameAddress) {
    //     if (!this.resrchForm.postcd && this.resrchForm.postcd.length <= 0) {
    //       this.errors['resrchPostcd'] = this.label.postcd + 'は必須項目です'
    //       ret = false
    //     } else if (!Check.isPostCd(this.resrchForm.postcd)) {
    //       this.errors['resrchPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
    //       ret = false
    //     } else if (!FormUtil.isExistPostcd(this.resrchForm.postcd)) {
    //       this.errors['resrchPostcd'] = this.label.postcd + 'が存在しません。'
    //       ret = false
    //     } else {
    //       delete this.errors.resrchPostcd
    //     }
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateExistDeliveryPostcd: function () {
    //   let ret = true
    //   if (this.deliveryForm.postcd.length > 0 && (!this.deliveryForm.state || !this.deliveryForm.city)) {
    //     this.errors['deliveryPostcd'] = this.label.postcd + 'が間違っています'
    //     ret = false
    //   } else {
    //     delete this.errors.deliveryPostcd
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateExistConstructPostcd: function () {
    //   let ret = true
    //   if (this.constructForm.postcd.length > 0 && (!this.constructForm.state || !this.constructForm.city)) {
    //     this.errors['constructPostcd'] = this.label.postcd + 'が間違っています'
    //     ret = false
    //   } else {
    //     delete this.errors.constructPostcd
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateExistResrchPostcd: function () {
    //   let ret = true
    //   if (this.resrchForm.postcd.length > 0 && (!this.resrchForm.state || !this.resrchForm.city)) {
    //     this.errors['resrchPostcd'] = this.label.postcd + 'が間違っています'
    //     ret = false
    //   } else {
    //     delete this.errors.resrchPostcd
    //   }
    //   this.$forceUpdate()
    //   return ret
    // },
    // validateDeliImpossiblePostCd: function (postcd, message) {
    //   if (!Check.checkDeliImposible(postcd)) {
    //     App.showModal({
    //       messages: message,
    //       onCancel: this.newTabSupport,
    //       modalType: 'confirm',
    //       okBtnLabel: 'キャンセル',
    //       cancelBtnLabel: 'お問い合わせ',
    //       layoutType: 'classic',
    //       textAlign: 'left'
    //     })
    //     return false
    //   }
    //   return true
    // },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    // formatPrice: function (price) {
    //   if (!price) return '￥0'
    //   let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    //   return '￥' + ret
    // },
    // doorColorContentNo: function () {
    //   if (this.doorColorList.length > 0) {
    //     return 1
    //   }
    // },
    // boxColorContentNo: function () {
    //   if (this.doorColorList.length > 0 && this.cabineColorList.length > 0) {
    //     return 2
    //   } else if (this.cabineColorList.length > 0) {
    //     return 1
    //   }
    // },
    // counterColorContentNo: function () {
    //   if (this.doorColorList.length > 0 && this.cabineColorList.length > 0 && this.counterColorList.length > 0) {
    //     return 3
    //   } else if ((this.doorColorList.length > 0 || this.cabineColorList.length > 0) && this.counterColorList.length > 0) {
    //     return 2
    //   } else {
    //     return 1
    //   }
    // },
    // titleDoor: function () {
    //   if (this.colorDoor != null) {
    //     return '3.扉カラー'
    //   }
    //   return ''
    // },
    // titleCabine: function () {
    //   if (this.colorDoor != null && this.colorCabine != null) {
    //     return '4.キャビネット/棚/脚カラー'
    //   } else if (this.colorCabine != null) {
    //     return '3.キャビネット/棚/脚カラー'
    //   }
    //   return ''
    // },
    // titleCounter: function () {
    //   if (this.colorCounter == null) {
    //     return ''
    //   }
    //   if (this.colorDoor != null && this.colorCabine != null) {
    //     return '5.カウンターカラー'
    //   } else if (this.colorDoor != null || this.colorCabine != null) {
    //     return '4.カウンターカラー'
    //   }
    //   return '3.カウンターカラー'
    // },
    closeMenu: function () {
      this.$refs.menuRef.close()
    },
    // changeResrchAdress: function () {
    //   if (this.isResrchSameAddress) {
    //     this.copyForm = Object.assign({}, this.resrchForm)
    //     this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
    //   } else {
    //     this.resrchForm = Object.assign(this.resrchForm, this.copyForm)
    //   }
    // },
    // changeNewInput: function () {
    //   delete this.errors.selectList
    //   delete this.errors.deliveryPostcd
    //   if (this.isExistDelivery) {
    //     // 新規から既存に切り替わったとき
    //     // 新規で入力していた値を一時退避
    //     this.saveForm = Object.assign({}, this.deliveryForm)
    //     if (this.selBusiness) {
    //       this.$set(this.deliveryForm, 'postcd', this.selBusiness.postcd)
    //     }
    //   } else {
    //     // 既存から新規に切り替わったとき
    //     if (Object.keys(this.saveForm).length > 0) {
    //       // 新規で入力していたら退避していた値を戻す
    //       this.deliveryForm = Object.assign({}, this.saveForm)
    //     } else {
    //       this.$set(this.deliveryForm, 'postcd', '')
    //     }
    //   }
    // },
    // changeNewStruct: function () {
    //   delete this.errors.constructPostcd
    //   if (!this.isStructSameAddress) {
    //     // 既存から新規に切り替わったとき
    //     if (Object.keys(this.saveConstructForm).length > 0) {
    //       // 新規で入力していたら退避していた値を戻す
    //       this.constructForm = Object.assign({}, this.saveConstructForm)
    //     } else {
    //       this.$set(this.constructForm, 'postcd', '')
    //     }
    //   } else {
    //     // 新規から既存に切り替わったとき
    //     // 新規で入力していた値を一時退避
    //     this.saveConstructForm = Object.assign({}, this.constructForm)
    //     this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
    //   }
    // },
    // changeResrch: function (status) {
    //   if (status === 1) {
    //     delete this.errors.selectList
    //     delete this.errors.deliveryPostcd
    //   } else {
    //     delete this.errors.resrchPostcd
    //   }
    //   this.$forceUpdate()
    // },
    // sizeName: function (w, h, d) {
    //   if (!w || !h || !d) return ''
    //   return w + '×' + h + '×' + d + '(mm)'
    // },
    // handleErrorMessage: function (response) {
    //   if (!response || !response.data) {
    //     return
    //   }
    //   let modalData = {
    //     title: 'エラー',
    //     messages: response.data.errorMessage.split(/\r?\n/g),
    //     messageType: 'error',
    //     textAlign: 'left'
    //   }
    //   App.showModal(modalData)
    // },
    // viewCorpInfo: function () {
    //   let modal = new Vue({
    //     el: '#modal',
    //     components: { 'dd-maker-info-modal': MakerInfoModal },
    //     data () {
    //       return {
    //         modalData: {}
    //       }
    //     },
    //     methods: {
    //     },
    //     template: `
    //       <dd-maker-info-modal ref="makerInfoModalRef"/>
    //     `
    //   }).$children[0]
    //   modal.showModal()
    // },
    // setPriceCalcTimer: function () {
    //   if (this.priceCalcTimer) return
    //   let _this = this
    //   this.priceCalcTimer = function () {
    //     _this.priceCalcText = _this.priceCalcText.replace('...', '') + '.'
    //   }
    //   setInterval(this.priceCalcTimer, 1000)
    // },
    // clearPriceCalcTimer: function () {
    //   clearInterval(this.priceCalcTimer)
    // },
    // changeWallFlag: function (flg) {
    //   this.isWallEmbedded = flg
    // },
    // profitPrice: function (price) {
    //   if (!price || !this.priceData) return
    //   return (Math.ceil(price / this.priceData.profitProb))
    // },
    // showErrorInput: function () {
    //   App.showModal({
    //     messages: ['入力内容を確認してください。'],
    //     onOk: this.onNew
    //   })
    // },
    customize: function (product) {
      App.setLocalStorage(DC_STORAGE_KEY.BUSINESS_DATA_LIST, this.businessDataList)
      App.setLocalStorage(DC_STORAGE_KEY.SELECT_PLAN, product)
      this.$router.push({
        name: 'DcCustomize'
      })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    productSize: function (min, max) {
      return (min + ' ≦ W ≦ ' + max)
    }
  }, // methods end
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    }
    // addressList: function () {
    //   if (!this.businessDataList || Object.keys(this.businessDataList).length <= 0) return {}
    //   return this.businessDataList.map(b => {
    //     return {
    //       businessId: b.businessId,
    //       businessName: b.businessName,
    //       postcd: b.businessPostcd,
    //       state: b.businessState,
    //       city: b.businessCity,
    //       street: b.businessStreet,
    //       building: b.businessBuilding,
    //       userLastName: b.businessPersonLastName1,
    //       userFirstName: b.businessPersonFirstName1,
    //       userLastNameKana: b.businessPersonLastNameKana1,
    //       userFirstNameKana: b.businessPersonFirstNameKana1,
    //       tel: b.businessTel
    //     }
    //   })
    // },
    // 以下はセットプラン取得時に企業情報をとれば不要になるはず。
    // corpData: function () {
    //   if (!this.targetPlan.corpData) return undefined
    //   let corpData = {
    //     corpName: this.targetPlan.corpData.corpName,
    //     postcd: this.targetPlan.corpData.postcd,
    //     address: ((this.targetPlan.corpData.state ? this.targetPlan.corpData.state : '') +
    //       (this.targetPlan.corpData.city ? this.targetPlan.corpData.city : '') +
    //       (this.targetPlan.corpData.street ? this.targetPlan.corpData.street : '')),
    //     tel: this.targetPlan.corpData.tel,
    //     fax: this.targetPlan.corpData.fax
    //   }
    //   return corpData
    // },
    // topForm: function () {
    //   let param = this.$refs.paramCommonRef.getParam()
    //   let payload = {
    //     dcFdId: this.targetPlan.dcFdId,
    //     dcCode: this.targetPlan.dcFdCode,
    //     dcWidth: param.width,
    //     dcHeight: param.height,
    //     dcHeight2: param.height2,
    //     dcDepth: param.depth,
    //     dcDepth2: param.depth2,
    //     dcBType: param.fillerTypeLeft,
    //     dcBSize: param.fillerSizeLeft,
    //     dcCType: param.fillerTypeRight,
    //     dcCSize: param.fillerSizeRight,
    //     dcDType: param.fillerTypeCounter,
    //     dcDSize: param.fillerSizeCounter,
    //     dcColorDoor: this.colorDoor !== null ? this.colorDoor.id : null,
    //     dcColorBox: this.colorCabine !== null ? this.colorCabine.id : null,
    //     dcColorCounter: this.colorCounter !== null ? this.colorCounter.id : null,
    //     dcShelfCount: this.opShelfCount,
    //     dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
    //     dcWorkFlag: this.isConstruct,
    //     dcProductCount: this.targetPlan.dcProductCount,
    //     dcSaveResrchFlag: this.resrchFlag === 1,
    //     dcSaveExistDeliFlag: this.isExistDelivery,
    //     dcSaveDeliPostcd: this.deliveryForm.postcd,
    //     dcSaveDeliState: this.deliveryForm.state,
    //     dcSaveDeliCity: this.deliveryForm.city,
    //     dcSaveDeliStreet: this.deliveryForm.street,
    //     dcStructPostcd: this.isStructSameAddress ? this.deliveryForm.postcd : this.constructForm.postcd,
    //     dcStructState: this.isStructSameAddress ? this.deliveryForm.state : this.constructForm.state,
    //     dcStructCity: this.isStructSameAddress ? this.deliveryForm.city : this.constructForm.city,
    //     dcStructStreet: this.isStructSameAddress ? this.deliveryForm.street : this.constructForm.street,
    //     dcConstructOpServiceFlag: this.isCarryFlag,
    //     businessId: this.selBusiness.businessId,
    //     // saveから持ってきた
    //     categoryId: this.selCategoryData.id,
    //     makerCorpId: this.targetPlan.corpId,
    //     colorTypeNo: this.targetPlan.dcFdColorType,
    //     dcStructSameAddressFlag: this.isStructSameAddress,
    //     dcSaveExistResrchFlag: false,
    //     dcSaveSameAddressFlag: this.isResrchSameAddress,
    //     dcSaveResrchPostcd: this.resrchForm.postcd
    //   }
    //   return payload
    // },
    // isSpaceJoincd: function () {
    //   if (!this.spaceJoincd) return false
    //   return true
    // },
    // isExecOrder: function () {
    //   if (!this.targetPlan.dcProductCount) return false
    //   if (this.targetPlan.dcProductCount === '' || Number(this.targetPlan.dcProductCount) <= 0) return false
    //   if (!this.colorDoor && !this.colorCabine && !this.colorCounter) return false
    //   if ((this.colorDoor && Object.keys(this.colorDoor).length <= 0) &&
    //      (this.colorCabine && Object.keys(this.colorCabine).length <= 0) &&
    //      (this.colorCounter && Object.keys(this.colorCounter).length <= 0)) return false
    //   if (this.isPlanning) return false
    //   return true
    // },
    // cabineColorList: function () {
    //   return this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.CABINE.code)
    // },
    // doorColorList: function () {
    //   return this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.DOOR.code)
    // },
    // counterColorList: function () {
    //   return this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.COUNTER.code)
    // },
    // TODO 組立設置例に使用していたが不要？
    // fileConstructList: function () {
    //   return this.constructList.filter(c => c.dcFdId === this.selOpenPlanData.dcFdId)
    // },
    // TODO option系、既に使用していないオプション復帰の可能性から残していたが、削除していい
    // attachShelfList: function () {
    //   if (!this.priceData.itemModelList) return
    //   return this.priceData.itemModelList
    //     .filter(e => e.accessoryType === 'PLAN')
    //     .filter(e => e.objectDtlType === 'UNIT_MOBILE_SHELF')
    // },
    // attachFillerList: function () {
    //   if (!this.priceData.itemModelList) return
    //   return this.priceData.itemModelList
    //     .filter(e => e.accessoryType === 'PLAN')
    //     .filter(e => e.objectDtlType === 'UNIT_FILLER')
    // },
    // optionShelfList: function () {
    //   if (!this.priceData.itemModelList) return
    //   return this.priceData.itemModelList
    //     .filter(e => e.accessoryType === 'OPTION')
    //     .filter(e => e.objectDtlType === 'UNIT_MOBILE_SHELF')
    // },
    // optionFillerList: function () {
    //   if (!this.priceData.itemModelList) return
    //   return this.priceData.itemModelList
    //     .filter(e => e.accessoryType === 'OPTION')
    //     .filter(e => e.objectDtlType === 'UNIT_FILLER')
    // },
    // getPageList: function () {
    //   let pageList = []

    //   if (this.resrchFlag === 1) {
    //     pageList.push({id: 'order', key: 'orderInput', title: '事前現場調査先入力'})
    //     pageList.push({id: 'input', key: 'buildingResearchInput', title: '事前現場調査項目入力'})
    //     pageList.push({id: 'confirm', key: 'orderConfirm', title: '事前現場調査内容確認'})
    //     pageList.push({id: 'complete', key: 'orderComp', title: '事前現場調査依頼完了'})
    //   } else {
    //     pageList.push({id: 'order', key: 'orderInput', title: '納品先入力'})
    //     if (this.isConstruct) {
    //       pageList.push({id: 'struct', key: 'struct', title: '組立設置情報入力'})
    //     }
    //     pageList.push({id: 'confirm', key: 'orderConfirm', title: 'ご注文内容確認'})
    //     if (!this.userInfo.isAccountPay) {
    //       pageList.push({id: 'payment', key: 'payment', title: 'お支払い方法選択'})
    //     }
    //     pageList.push({id: 'complete', key: 'orderComp', title: '注文完了'})
    //   }
    //   return pageList
    // },
    // isResearch: function () {
    //   return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED && this.selCategoryData.id !== 5)
    // },
    // isCarry: function () {
    //   if (this.selCategoryData.id === 4 || this.selCategoryData.id === 10 || this.selCategoryData.id === 11 ||
    //     this.selCategoryData.id === 12 || this.selCategoryData.id === 13) return false
    //   return true
    // },
    // productList: function () {
    //   return this.dcFileDataList.map(p => {
    //     return {
    //       id: p.dcFdId,
    //       name: p.dcFdName,
    //       img: p.dcFdImage
    //     }
    //   })
    // },
    // fillerSCImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerTVFImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile2.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerBSAImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile3.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerBSBImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile4.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerDKFImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile5.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerDKWImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile6.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerCLLImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile7.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerCLTAImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile8.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerCLTBImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile9.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerCLTCImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile10.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSBImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile11.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSLMImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile12.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSLTImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile13.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSOImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile14.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSRMImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile15.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // fillerNSRTImg: function () {
    //   if (!this.selOpenPlanData) return false
    //   let b = ptnFile16.test(this.selOpenPlanData.dcFdImage)
    //   return b
    // },
    // estimteBtnTitle: function () {
    //   if (this.selCategoryData.id === 5) return '見積り'
    //   return '図面/見積り'
    // },
    // opShelfCount: function () {
    //   if (this.selCategoryData.id === 5) {
    //     return this.dcBoardCount ? this.dcBoardCount : 0
    //   }
    //   return this.isAddShelf ? this.dcShelfCount : 0
    // },
    // isPlanning: function () {
    //   // return (this.runPlanList.length > 0 || this.createPlanFlag)
    //   return this.createPlanFlag
    // },
    // isCarryFlag: function () {
    //   // 受け取り搬入が使用可能か
    //   if (!this.isCarry) return undefined
    //   if (!this.isResearch) return undefined
    //   // 施工ありか
    //   if (!this.workFlag) return 0
    //   return this.constructOpFlag ? 1 : 0
    // },
    // isSelectConstruct: function () {
    //   if (this.selCategoryData.id === 4) {
    //     return !this.isWallEmbedded
    //   }
    //   return true
    // },
    // isConstruct: function () {
    //   if (!this.isSelectConstruct) return false
    //   return this.workFlag === 1
    // },
    // isMiuraCompany: function () {
    //   if (this.selCategoryData.id === 4 || this.selCategoryData.id === 10 || this.selCategoryData.id === 11 ||
    //     this.selCategoryData.id === 12 || this.selCategoryData.id === 13) {
    //     return true
    //   }
    //   return false
    // }
  }, // computed end
  // watch: {
  //   'deliveryForm.postcd': function () {
  //     if (this.isStructSameAddress) {
  //       this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
  //     }
  //     if (this.isResrchSameAddress) {
  //       this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
  //     }
  //   }
  // },
  mounted: function () {
    this.init(this.selectedCategory)
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.$store.dispatch('loadCartData', {reload: true})
    // 選択中のカテゴリがあれば初期値にする
    let lplan = App.getLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
    if (lplan && Object.keys(lplan).length > 0) {
      this.selectedCategory = lplan.dcCategoryType
    }
  }
}
</script>
<style src="../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../css/dc-common.scss" lang="scss" scoped></style>
<style src="../css/dctop3.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcTop.vue